export type OzRuntimeConfig = {
    REACT_APP_API_URI_STAGING?: string;
    REACT_APP_API_URI_PRODUCTION?: string;
    REACT_APP_DOWNLOAD_URL_STAGING?: string;
    REACT_APP_DOWNLOAD_URL_PRODUCTION?: string;
    REACT_APP_KEYCLOAK_URL_STAGING?: string;
    REACT_APP_KEYCLOAK_URL_PRODUCTION?: string;
    KEYCLOAK_REALM?: string;
    KEYCLOAK_CLIENT_ID?: string;
};

declare global {
    interface Window {
        __OZ_RUNTIME_CONFIG__?: OzRuntimeConfig;
    }
}

function getRuntime(): OzRuntimeConfig {
    if (typeof window === 'undefined') {
        return {};
    }
    return window.__OZ_RUNTIME_CONFIG__ || {};
}

/**
 * Merge order: `config.js` on window, then CRA `process.env` (optional key), then default.
 */
export function pickConfig(
    runtimeKey: keyof OzRuntimeConfig,
    defaultValue: string,
    processEnvKey?: string,
): string {
    const fromWindow = getRuntime()[runtimeKey];
    if (typeof fromWindow === 'string' && fromWindow.length > 0) {
        return fromWindow;
    }
    if (processEnvKey) {
        const fromEnv = process.env[processEnvKey];
        if (typeof fromEnv === 'string' && fromEnv.length > 0) {
            return fromEnv;
        }
    }
    return defaultValue;
}
